{
    "name": "Dirk",
    "version": "8.2.0",
    "private": true,
    "license": "MIT",
    "scripts": {
        "ng": "ng",
        "postinstall": "rm -rf node_modules/@fortawesome/fontawesome-pro/svgs node_modules/@fortawesome/fontawesome-pro/sprites node_modules/@fortawesome/fontawesome-pro/metadata node_modules/@fortawesome/fontawesome-pro/js",
        "start": "ng serve",
        "test": "vitest run",
        "test:unit:ci": "vitest run --reporter=default --reporter=junit --outputFile.junit=test-results/junit.xml",
        "build": "ng build --configuration=development",
        "build-production": "ng build --configuration=production",
        "build-acceptance": "ng build --configuration=acceptance",
        "build-test": "ng build --configuration=test",
        "build:cap": "ng build --configuration capacitor",
        "cap:sync": "npx cap sync",
        "set-version": "node set-version.js",
        "cap:assets": "npx capacitor-assets generate --assetPath assets --androidProject android --iosProject ios/App",
        "cap:android": "node set-version.js && ng build --configuration capacitor && npx cap sync && cd android && ./gradlew assembleDebug",
        "cap:android:release": "node set-version.js && ng build --configuration capacitor && npx cap sync && cd android && ./gradlew assembleRelease -PKEYSTORE_PASSWORD=${KEYSTORE_PASSWORD}",
        "cap:android:bundle": "node set-version.js && ng build --configuration capacitor && npx cap sync && cd android && ./gradlew bundleRelease -PKEYSTORE_PASSWORD=${KEYSTORE_PASSWORD}",
        "cap:ios": "npx cap open ios",
        "cap:ios:release": "node set-version.js && ng build --configuration capacitor && npx cap sync && npx cap open ios",
        "cap:ios:archive": "node set-version.js && ng build --configuration capacitor && npx cap sync && xcodebuild -workspace ios/App/App.xcworkspace -scheme App -configuration Release -archivePath ios/build/App.xcarchive archive"
    },
    "dependencies": {
        "@angular/animations": "20.3.26",
        "@angular/cdk": "20.2.14",
        "@angular/common": "20.3.26",
        "@angular/compiler": "20.3.26",
        "@angular/core": "20.3.26",
        "@angular/forms": "20.3.26",
        "@angular/google-maps": "20.2.14",
        "@angular/material": "20.2.14",
        "@angular/platform-browser": "20.3.26",
        "@angular/platform-browser-dynamic": "20.3.26",
        "@angular/router": "20.3.26",
        "@capacitor-community/file-opener": "8.0.1",
        "@capacitor-firebase/messaging": "8.3.0",
        "@capacitor/android": "8.5.0",
        "@capacitor/app": "8.1.1",
        "@capacitor/app-launcher": "8.0.1",
        "@capacitor/browser": "8.0.4",
        "@capacitor/camera": "8.2.2",
        "@capacitor/cli": "8.5.0",
        "@capacitor/core": "8.5.0",
        "@capacitor/dialog": "8.0.1",
        "@capacitor/file-viewer": "2.0.2",
        "@capacitor/filesystem": "8.1.3",
        "@capacitor/geolocation": "8.2.2",
        "@capacitor/ios": "8.5.0",
        "@capacitor/keyboard": "8.0.5",
        "@capgo/capacitor-intent-launcher": "8.3.25",
        "@fortawesome/fontawesome-pro": "file:node_modules_local/fortawesome-fontawesome-pro-6.5.1.tgz",
        "@iharbeck/ngx-virtual-scroller": "16.0.0",
        "@ng-select/ng-select": "20.7.0",
        "@swimlane/ngx-charts": "20.5.0",
        "@turf/turf": "7.4.0",
        "angular-svg-icon": "16.1.0",
        "angularx-qrcode": "20.0.0",
        "bootstrap": "5.3.8",
        "exceljs": "4.2.0",
        "file-saver": "2.0.5",
        "firebase": "12.17.1",
        "jszip": "3.10.1",
        "ngx-drag-drop": "20.0.1",
        "ngx-ui-scroll": "3.2.2",
        "pdfjs-dist": "4.10.38",
        "rd-to-wgs84": "2.0.0",
        "rxjs": "7.8.0",
        "shpjs": "6.2.0",
        "swiper": "11.2.10",
        "tinymce": "5.10.9",
        "tinymce-i18n": "20.12.25",
        "tslib": "2.8.1",
        "xlsx": "0.18.5",
        "zone.js": "0.15.1"
    },
    "devDependencies": {
        "@angular/build": "20.3.32",
        "@angular/cli": "20.3.32",
        "@angular/compiler-cli": "20.3.26",
        "@capacitor/assets": "3.0.5",
        "@types/file-saver": "2.0.7",
        "@types/shpjs": "3.4.7",
        "typescript": "5.8.3",
        "vitest": "3.2.7"
    },
    "engines": {
        "node": "22.23.4"
    },
    "versiontime": 1711614652200
}
